import { Button, Group, Popover, ScrollArea, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { DiscountReportOrder } from 'washday-sdk';

export type DiscountCodeReportOrder = DiscountReportOrder;

const INLINE_FOLIOS_LIMIT = 3;
const SUMMARY_FOLIOS_COUNT = 2;

export default function FoliosCell({ orders }: { orders: DiscountCodeReportOrder[] }) {
  const { t } = useTranslation('ReportsPage');
  const folios = orders.map(({ folio }) => folio);

  if (folios.length === 0) {
    return <Text c="dimmed">—</Text>;
  }

  if (folios.length <= INLINE_FOLIOS_LIMIT) {
    return <Text size="sm">{folios.join(', ')}</Text>;
  }

  const hiddenFoliosCount = folios.length - SUMMARY_FOLIOS_COUNT;

  return (
    <Group gap="xs" wrap="nowrap" align="flex-start">
      <Text size="sm">{folios.slice(0, SUMMARY_FOLIOS_COUNT).join(', ')}</Text>
      <Popover width={260} position="bottom" withArrow shadow="md">
        <Popover.Target>
          <Button variant="subtle" size="compact-xs">
            {t('discountCodesReport.viewFolios')} (+{hiddenFoliosCount})
          </Button>
        </Popover.Target>
        <Popover.Dropdown>
          <ScrollArea.Autosize mah={240}>
            <Stack gap={4}>
              {orders.map(({ orderId, folio }) => (
                <Text key={orderId} size="sm">
                  {folio}
                </Text>
              ))}
            </Stack>
          </ScrollArea.Autosize>
        </Popover.Dropdown>
      </Popover>
    </Group>
  );
}
